import { mobileSkeletonLoader } from 'app/modules/step-engine/utils/step-engine-methods';
import { IRootState } from 'app/shared/reducers';
import { useSelector } from 'react-redux';
import { Step } from '../../utils/step-engine-constants';
import React from 'react';
export interface ISkeletonStepsProps {
  steps: string[];
}

const MobileSkeletonSteps = (props: ISkeletonStepsProps) => {
  const currentStep = useSelector((state: IRootState) => state.stepEngine.stepData.receivedStep);
  const getNextSkeleton = () => {
    return Step[currentStep[0]];
  };
  return <>{mobileSkeletonLoader(currentStep === null ? 'genericMobileSkel' : getNextSkeleton())}</>;
};

export default MobileSkeletonSteps;
